import { ITabs, ITabsState } from '@/components/tabs/useTabs';

export const enum DocumentsModule {
  Internal = 'internal',
  Inbox = 'inbox',
}

const tabs = {
  [DocumentsModule.Internal]: 'Внутренние\nдокументы',
  [DocumentsModule.Inbox]: 'Входящие\nдокументы',
};

export const useModuleTabs = (): ITabs => ({
  state: ITabsState.quaternary,
  tabs: Object.keys(tabs)
    .map((tabName) => ({
      key: tabName,
      id: `documents_page_${tabName}_tab`,
      label: tabs[tabName as keyof typeof tabs],
      to: {
        name: 'documents-module',
        params: {
          module: tabName,
        },
      },
    })),
});
